// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604291629/js/" + chunkId + "." + {"44":"bdef5c32","225":"cc99c34f","481":"1c86d375","486":"fd0a1b33","770":"90c80526"}[chunkId] + ".0.6136547852281775.chunk.js";
};